import React, { useState } from "react";
import { setScorePostApi } from "../../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import Button from "../../../Button/Button";
import Style from "./SetScore.module.scss";

const SetScore = ({ rawInfo, handleOkAddress, UserList }) => {
  const [score, setScore] = useState();
  const [disable, setDisable] = useState(false);

  const sendScore = () => {
    setDisable(true);
    let info = {
      id: rawInfo.id,
      score: score,
    };
    setScorePostApi(info, (suc) => {
      if (suc.status === 1) {
        succToast(suc.message);
        setDisable(false);
      } else {
        errorToast(suc.message);
        setDisable(false);
      }
    });
    handleOkAddress();
    UserList();
  };
  return (
    <div className={Style.componentHolder}>
      <input
        className={Style.scoreInput}
        placeholder={"مثال:2000"}
        value={score}
        onChange={(e) => setScore(e.target.value)}
      />
      <Button
        ClassBtn={"okBtn"}
        Value={"تایید"}
        ClickHandler={sendScore}
        disabledprops={disable}
      />
    </div>
  );
};

export default SetScore;
